module.exports = __webpack_public_path__ + "media/24.1bc4b15f.mp3";